export default {"src":"/_next/static/media/sub_out.84b88cfa.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};